import ProfileEmail from '@/components/profile/email';

export default ProfileEmail;
